import type { TransactionOperation } from "."
import { panelFillState } from "../panels"

export const changePanelFillState: TransactionOperation<undefined, string> = ({
  set,
}) => {
  set(panelFillState, `Opaque`)

  return `Opaque`
}
